import { Radio as PomodoroRadio } from '@ifood/pomodoro-components';
import { useField, useFormikContext } from 'formik';
import React, { FC } from 'react';

import { FieldName } from 'types/form';
import { PropsOf } from 'types/jsx';

import { PomodoroButton } from './styles';

export type RadioButtonProps = {
  name: FieldName<string>;
} & PropsOf<typeof PomodoroRadio.Button>;

const Button: FC<RadioButtonProps> = ({ name, value: selfValue, ...props }) => {
  const formik = useFormikContext();

  const [{ value: formValue }] = useField(name);

  return (
    <PomodoroButton
      name={name}
      value={selfValue}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      checked={formValue === selfValue}
      {...props}
    />
  );
};

export type RadioGroupProps = {
  name: FieldName<string>;
} & PropsOf<typeof PomodoroRadio.Group>;

const Group: FC<RadioGroupProps> = ({ name, ...props }) => {
  const [, { error, touched }] = useField(name);

  return <PomodoroRadio.Group error={touched ? error : undefined} {...props} />;
};

type RadioComposition = {
  Button: typeof Button;
  Group: typeof Group;
};

export const Radio: RadioComposition = {
  Button,
  Group,
};
